import { DotRangeDays } from '../types';

export const getNumberWithOrdinal = (n: number) => {
  const s = ['th', 'st', 'nd', 'rd'],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

// Calculate date ranges how many days are overlapping for each day.
export const countDatesOccurrences = (data: DotRangeDays) => {
  // Initialize an empty object to store the counts
  const dateCounts: { [key: string]: number } = {};

  // Extract start and end dates and count them
  data.forEach((item) => {
    // Extract the start and end dates
    const startDate = new Date(item.startDate);
    const endDate = new Date(item.endDate);

    // Count occurrences for the start date
    const startDateStr = startDate.toDateString();
    if (startDateStr in dateCounts) {
      dateCounts[startDateStr]++;
    } else {
      dateCounts[startDateStr] = 1;
    }

    // Count occurrences for the end date
    const endDateStr = endDate.toDateString();
    if (endDateStr in dateCounts) {
      dateCounts[endDateStr]++;
    } else {
      dateCounts[endDateStr] = 1;
    }
  });

  // Extract all dates between start and end dates and count them
  data.forEach((item) => {
    const startDate = new Date(item.startDate);
    const endDate = new Date(item.endDate);

    const currentDate = new Date(startDate);
    currentDate.setDate(currentDate.getDate() + 1);

    const currentEndDate = new Date(endDate);

    // Count occurrences for all dates between start and end dates
    while (currentDate < currentEndDate) {
      const currentDateStr = currentDate.toDateString();
      if (currentDateStr in dateCounts) {
        dateCounts[currentDateStr]++;
      } else {
        dateCounts[currentDateStr] = 1;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
  });

  return dateCounts;
};
